import { max } from "mathjs";
import Stat from "models/Stat";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { ServiceLocatorContext } from "./ServiceLocatorContext";

export const StatContext = createContext(null);

const StatProvider = ({ children }) => {
    const { localStorageService, statComputationService } = useContext(ServiceLocatorContext);


    const [state, setState] = useState({
        stats: []
    });
    const initRef = useRef(false);


    // Initialize before first render.
    if (!initRef.current) {
        const stats = localStorageService.loadDefaultStats();
        statComputationService.initContext(stats);
        setState({ stats });
        initRef.current = true;
    }

    /**
     * Saves the given stats in the state as well as in localStorage.
     * 
     * @param {Array.<Stat>} stats 
     */
    const _saveStats = (stats) => {
        setState({ stats });
        localStorageService.saveDefaultStats(stats);
    };


    const addStat = () => {
        const newId = state.stats.length > 0 ? max(state.stats.map(stat => stat.id)) : 1;
        const stat = new Stat({ id: newId + 1, name: 'STAT_' + newId });
        statComputationService.updateFormulaDepsCache(stat);
        _saveStats([...state.stats, stat]);
    };

    const updateStat = (stat) => {
        const stats = state.stats.map((st) => st.id === stat.id ? stat : st);
        statComputationService.updateFormulaDepsCache(stat);
        _saveStats(stats);
    }

    const removeStat = (statId) => {
        const stats = state.stats.filter((stat) => stat.id !== statId);
        statComputationService.deleteStatFormulaDepsCacheId(statId);
        _saveStats(stats);
    }

    return (
        <StatContext.Provider value={{ addStat, updateStat, removeStat, stats: state.stats.slice(), computedCache: { ...statComputationService.computedCache } }}>
            {children}
        </StatContext.Provider>
    )
};

export default StatProvider;